import React from "react";
import { Grid, Typography } from "@mui/material";

export default function Footer() {
    return (
      <div style={{marginTop:'80px',padding:'20px'}}>
        <Grid container style={{}} justifyContent="center" alignItems="center">
          <Grid item>
            <Typography
              color="gray"
              style={{
                fontFamily: "Getboreg Trial Only",
                textAlign: "center",
                fontSize: "13px",
              }}
            >
              © TH4RIN, 2024. All rights reserved.
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
}
